import { createFileRoute } from '@tanstack/react-router';

import { ResearchCenterCreate } from '@/module/ResearchCenter/ResearchCenterCreate';

export const Route = createFileRoute('/_auth/research-center/_research-center/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ResearchCenterCreate />;
}
